import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
// ArgoCD (Roadie): the package's `.` export is the legacy plugin; the new-frontend-system plugin
// lives at `/alpha`. Listed explicitly (rather than left to `packages: all` discovery) so the alpha
// entrypoint is chosen deterministically over the legacy default. Provides the argocd api + the
// entity-card:argocd/overviewCard & historyCard extensions (filtered via app-config app.extensions).
import argocdPlugin from '@roadiehq/backstage-plugin-argo-cd/alpha';
import { navModule } from './modules/nav';
import { signInModule } from './modules/signInPage';
import { mermaidModule } from './modules/mermaid';
// GitHub PRs (Roadie) has no /alpha — bridged to the new frontend system via this local module.
// (GitHub Actions and Grafana ship native /alpha and are picked up by `packages: all` discovery.)
import { githubPullRequestsModule } from './modules/githubPullRequests';

export default createApp({
  features: [
    catalogPlugin,
    argocdPlugin,
    githubPullRequestsModule,
    navModule,
    signInModule,
    mermaidModule,
  ],
});
